import { render, staticRenderFns } from "./ElementHolder.vue?vue&type=template&id=5a48c1f6&scoped=true&"
import script from "./ElementHolder.vue?vue&type=script&lang=ts&"
export * from "./ElementHolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48c1f6",
  null
  
)

export default component.exports